import test_sound from '../../assets/audio/test_sound.mp3';
import SetupStep from './SetupStep';
import { useLanguage } from '../contexts/language';
import SelectedExperienceChip from './SelectedExperienceChip';

export function SetupAudio(p) {
  const { content } = useLanguage();
  return (
    <>
      <SetupStep
        pretitle={content('raise_volume')}
        title={content('sound')}
        image="phone"
        badge={<SelectedExperienceChip />}
        action={content('yes_continue')}
        themeSwitcher
        stepNav
        {...p}
      />
      <audio src={test_sound} autoPlay loop style={{ display: 'none' }} />
    </>
  );
}
